"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KofiButton;

require("./style.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _kofiColors = _interopRequireDefault(require("../functions/kofiColors"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var known_presets = ["", "default", "thin", "skinny", "circle", "no_background"];

function KofiButton(_ref) {
  var username = _ref.username,
      label = _ref.label,
      title = _ref.title,
      preset = _ref.preset,
      backgroundColor = _ref.backgroundColor,
      animation = _ref.animation;
  username = username || "costasak";
  var profile_url = "https://ko-fi.com/" + username;

  if (preset && !known_presets.includes(preset)) {
    console.warn("Unknown preset \"".concat(preset, "\", reverting to default"));
    preset = "";
  }

  if (preset === "default") {
    preset = "";
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "KofiContainer",
    style: {
      "--background-color": (0, _kofiColors.default)(backgroundColor)
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
      className: "KofiButton " + preset,
      href: profile_url,
      target: "_blank",
      rel: "noreferrer noopener external",
      title: title,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("figure", {
        className: "KofiImageContainer",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "KofiImage animation_" + animation,
          alt: ""
        })
      }), label && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "KofiText",
        children: label
      })]
    })
  });
}

KofiButton.propTypes = {
  username: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  title: _propTypes.default.string,
  preset: _propTypes.default.oneOf(known_presets),
  backgroundColor: _propTypes.default.string,
  animation: _propTypes.default.oneOf([true, false, "true", "false", "on_hover"])
};
KofiButton.defaultProps = {
  label: "Support Me on Ko-fi",
  title: "",
  backgroundColor: "kofiBlue",
  animation: true
};